export const OVER_UNDER = 'OVER_UNDER' as const;
export const SCORE = 'SCORE' as const;
export const SPREAD = 'SPREAD' as const;
export const WIN = 'WIN' as const;
export const PointSpread = 'Point Spread' as const;
export const TotalPoints = 'Total Points' as const;
export const TotalRuns = 'Total Runs' as const;
export const Moneyline = 'Moneyline' as const;

export const marketTypes = [OVER_UNDER, SCORE, SPREAD, WIN] as const;

export const marketMeta = {
	[PointSpread]: {
		heading: 'Spread',
		info: 'Spread Line',
		betsTooltipText: `The % of the total number of bets on the spread placed on each team`,
		moneyTooltipText: `The % of the total money wagered on the spread bet on each team.`,
	},
	[Moneyline]: {
		heading: 'Moneyline (ML)',
		info: 'Moneyline Odds',
		betsTooltipText: `The % of the total number of bets on the moneyline placed on each team.`,
		moneyTooltipText: `The % of the total money wagered on the moneyline bet on each team.`,
	},
	[TotalPoints]: {
		heading: '',
		info: '',
		betsTooltipText: `The % of the total number of bets on the total points placed on the over or the under.`,
		moneyTooltipText: `The % of the total money wagered on the total points bet on the over or the under.`,
	},
	[TotalRuns]: {
		heading: '',
		info: '',
		betsTooltipText: `The % of the total number of bets on the total runs placed on the over or the under.`,
		moneyTooltipText: `The % of the total money wagered on the total runs bet on the over or the under.`,
	},
};
